var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWangke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 674",
    d: "M5 8.09375L4.28125 3.625L8.78125 4.625L13.3438 3.53125L12.625 8.09375L13.2188 12.5469L8.78125 11.9375L4.28125 12.5469L5 8.09375Z",
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 54",
    x1: 8.8125,
    y1: 1.21875,
    x2: 8.8125,
    y2: 14.7812,
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 55",
    x1: 15.0937,
    y1: 8.0625,
    x2: 1.53125,
    y2: 8.0625,
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 56",
    x1: 13.3789,
    y1: 12.7111,
    x2: 3.78873,
    y2: 3.12099,
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 57",
    x1: 4.16354,
    y1: 12.8165,
    x2: 13.7537,
    y2: 3.22636,
    stroke: "#2F88FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 92",
    cx: 8.75,
    cy: 8,
    r: 6.8125,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWangke);
export default __webpack_public_path__ + "static/media/wangke.5576847d84ea875d2fb61ec29e6cca51.svg";
export { ForwardRef as ReactComponent };